<template>
    <div class="login-box">
        <em class="logo ng-scope"></em>
        <div class="login-form">
            <div class="col col-md-4 centered my-auto">
                <div class="login-text ng-scope">
                    <h3>Forbidden</h3>
                    <p>You are not authorized to view the requested page.</p>
                </div>
                <div class="fields">
                    <div class="actions">
                        <p class="centered">
                            <a class="login-text text-center" v-on:click="returnToLast()">Return</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  methods: {
    returnToLast () {
      this.$router.go(-2);
    }
  }
};
</script>
<style lang="scss" scoped>
.logo {
    overflow: hidden;
    background: url(/static/img/logo.png);
    background-size: 288px 90px;
    width: 288px;
    height: 90px;
    margin: auto;
}

#send-email {
    width: 100%;
    background-color: rgb(0, 168, 202) !important;
    color: white;
}

.login-text {
    width: 420px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/error/Forbidden.vue